import { useRoute } from '@react-navigation/native';
import React from 'react';
import { StyleSheet, useWindowDimensions, View } from 'react-native';
import { ContributionPhotoListItemZoomed } from '../../components/molecules/ContributionPhotoList';
import { useQuery } from '@tanstack/react-query';
import { getFileDetails } from '../../services/api/file.api';
import { match, P } from 'ts-pattern';
import { ContributionMedia } from '../../entities/ContributionMedia';

export default function FileViewerScreen() {
  const route = useRoute();
  const params = (route.params || {}) as { file_id?: string | null };
  const windowDimensions = useWindowDimensions();

  const parsed_file_id = params.file_id && parseInt(params.file_id, 10);
  const file_id = parsed_file_id && !isNaN(parsed_file_id) ? parsed_file_id : null;

  const { data: file } = useQuery(
    ['getFileDetails', getFileDetails(file_id || 0)],
    async () => {
      return await getFileDetails(file_id || 0);
    },
    {
      enabled: !!file_id,
    }
  );

  const item =
    file &&
    match(file.format)
      .with(
        P.union('image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/svg+xml'),
        () =>
          ({
            id: file.id,
            contributionId: 0,
            imageId: file.id,
            videoUrl: null,
            documentId: null,
          } as Partial<ContributionMedia>)
      )
      .with(
        'application/pdf',
        () =>
          ({
            id: file.id,
            contributionId: 0,
            imageId: null,
            videoUrl: null,
            documentId: file.id,
          } as Partial<ContributionMedia>)
      )
      .otherwise(() => null);

  return (
    <View style={styles.container}>
      {item && (
        <ContributionPhotoListItemZoomed
          index={0}
          item={item}
          width={windowDimensions.width}
          height={windowDimensions.height}
          selected
          resizeMode="contain"
          zoomEnabled
        />
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});
